import oAxiosInstance from "config/Axios";

export const apiCallGetAllReceipts = oData => {
  return oAxiosInstance.post("recibos/consultar", oData);
};

export const apiCallReceiptsExportToCsv = oData => {
  return oAxiosInstance.post("recibos/exportarcsv", oData);
};

export const apiCallReceiptsFind = nId => {
  return oAxiosInstance.get(`recibos/consultarCabezal/${nId}`);
};

export const apiCallReceiptsFindLines = nId => {
  return oAxiosInstance.get(`recibos/consultarLineas/${nId}`);
};

export const apiCallReceiptsSave = oData => {
  return oAxiosInstance.post("recibos", oData);
};

export const apiCallReceiptsCancel = nId => {
  return oAxiosInstance.get(`recibos/anular/${nId}`);
};

export const apiCallSendReceiptToEmail = (nId) => {
  // Aquí usamos el segundo argumento de `.get()` para pasar la configuración.
  return oAxiosInstance.get(`efactura/enviarcfemail/${nId}/R`, {
    // La propiedad `validateStatus` define qué códigos de estado son exitosos.
    // Con esta función, decimos que son exitosos si el estado es 204
    // o si está entre 200 y 300 (el rango por defecto).
    validateStatus: function(status) {
      return status === 204 || (status >= 200 && status < 300);
    },
  });
};
